import React from "react";
import { useHistory } from "react-router-dom";
import { Breadcrumb, BreadcrumbItem } from "sprint-common-web";

import { MovieContentSubtype } from "../../../common/types/MovieContentSubtype";
import { assetsSearchRoutes } from "../../AssetsRoutes";
import { getSearchAssetRouteItemByContentSubtype } from "../../search/getSearchAssetPathByType";

interface MovieAssetsListBreadcrumbsProps {
    movieTitle: string;
    subtype: MovieContentSubtype;
    isLoading: boolean;
}

export const MovieAssetsListBreadcrumbs: React.FC<MovieAssetsListBreadcrumbsProps> = (
    props: MovieAssetsListBreadcrumbsProps
) => {
    const history = useHistory();

    const { movieTitle, subtype, isLoading } = props;

    const goToMovieAssetsSearchPage = () => {
        const routeItem = getSearchAssetRouteItemByContentSubtype(subtype);
        history.push(routeItem.path);
    };

    const items: BreadcrumbItem[] = [
        ...assetsSearchRoutes.baseRouteNames.map((name: string) => {
            return { key: name, text: name };
        }),
        {
            key: "search-breadcrumb",
            text: getSearchAssetRouteItemByContentSubtype(subtype).name,
            onClick: goToMovieAssetsSearchPage
        },
        {
            key: "movie-title-breadcrumb",
            text: `${movieTitle}`
        }
    ];

    return <Breadcrumb items={items} isLoading={isLoading} />;
};
